import React from "react";
import styled from "@emotion/styled";
import { Tel } from "./tel";

const StyledFooter = styled.footer`
  display: flex;
  justify-content: space-between;
  text-align: center;
  padding: var(--xl) 0;
  font-size: var(--small);

  @media (max-width: 620px) {
    flex-direction: column;
    gap: var(--sm);
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Updated alignment to left */
    gap: var(--sm);

    @media (max-width: 620px) {
      align-items: center;
    }
  }
`;

export const Footer = () => (
  <div className="row">
    <StyledFooter>
      <div>
        <p>&copy; Tolo Construction</p>
        <p>CA License # 1096239</p>
      </div>
      <div>
        <p>Serving the San Francisco Bay Area</p>
        <Tel />
      </div>
    </StyledFooter>
  </div>
);